import React, { useState } from 'react';
import { get, isEmpty } from 'lodash';
import { toast } from 'react-toastify';
import { TextField } from '@material-ui/core';
import { IntlShape, injectIntl } from 'react-intl';
import { StyledDiv } from 'containers/CourtManagerLegalProceedings/ExpertiseExpert/Dialog/styles';
import DecisionDialog from 'components/DecisionDialog/index';
import { translate } from 'containers/services/translate';
import messages from 'containers/CourtManagerLegalProceedings/ExpertiseExpert/messages';
import { MISSION_EXPERISE_VICTIM_STATUS } from 'containers/data-structure';
import currentUserStorage from 'containers/services/security/current-user-storage';
import {
  EXPERTISE_ACCOUNTING_ID,
  EXPERTISE_MECHANIC_ID,
} from 'containers/CourtManagerLegalProceedings/constants';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';

export interface RejectionDialogProps {
  intl: IntlShape;
  open: boolean;
  onClose: Function;
  validateDialog: Function;
  recap: any;
  claimNumber: string;
  transactionId?: any;
  timelineId?: any;
}

const RejectionDialog: React.FC<RejectionDialogProps> = (
  props,
): JSX.Element => {
  const { onClose, open } = props;
  const [reason, setReason] = useState('');
  const handleChangeReason = (event: any) => {
    setReason(event.target.value);
  };
  const successCallBack = () => {
    toast.success(translate(messages.toastRejectionSuccess, props));
    props.onClose();
  };
  const handleValidate = () => {
    props.validateDialog(
      {
        status: MISSION_EXPERISE_VICTIM_STATUS.REJECTED,
        id: get(props.recap, 'id'),
        decidedBy: currentUserStorage.get().username,
        rejectionReason: reason,
        claimId: get(props.recap, 'claimId'),
        missionId: get(props.recap, 'missionId'),
        expertCode: get(props.recap, 'createdBy'),
        claimNumber: props.claimNumber,
        isInboxesActive: featureService.hasFeature(
          FEATURES.ATTRIBUTION_INBOXES_MANAGER,
        ),
        isTrackingActive: featureService.hasFeature(
          FEATURES.TRACKING_ACTIONS_USER,
        ),
        timelineId: props.timelineId,
        transactionId: props.transactionId,
        isVehicle:
          Number(get(props.recap, 'mission.type', '')) ===
            EXPERTISE_MECHANIC_ID ||
          (Number(get(props.recap, 'mission.type', '')) ===
            EXPERTISE_ACCOUNTING_ID &&
            !isEmpty(get(props.recap, 'mission.missionVehicle', [])))
            ? true
            : false,
      },
      successCallBack,
    );
  };
  return (
    <DecisionDialog
      open={open}
      onClose={onClose}
      validateDialog={handleValidate}
      title={translate({ ...messages.decisionTitle }, props)}
      content={
        <StyledDiv>
          <TextField
            onChange={handleChangeReason}
            name={'reason'}
            value={reason}
            label={translate({ ...messages.reason }, props)}
            className="input"
            multiline
            fullWidth
          />
        </StyledDiv>
      }
      disabled={!reason}
      primaryButtonTitle={translate(messages.dialogValidationButton, props)}
      scondaryButtonTitle={translate(messages.dialogCancelButton, props)}
    />
  );
};

RejectionDialog.defaultProps = {
  open: false,
};

export default injectIntl(RejectionDialog);
